module.exports = __webpack_public_path__ + "img/main-01-10.8688c73d.png";